import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Loader from "react-loader";
import { Player, BigPlayButton } from "video-react";
import Vimeo from "../../../../components/VimeoPlayer/VimeoPlayer.Component";
import { toast, ToastContainer } from "react-toastify";
import Modal from "react-awesome-modal";

import withServices from "src/HOCs/withServices";
import { PROXIED_MEDIABASE } from "../../../../common/constants";
import Navbar from "../../../../components/CustomNav/CustomNav.Component";
import {
  Page,
  HeaderSection,
  Grid,
  AssetItem,
  ModalWrapper,
  VideoItem,
  EditRow,
  CollectionInfo
} from "./AssetCollections.styles";

interface IProps {
  match: any;
  history: any;
  services: any;
}

class AssetCollections extends Component<IProps, any> {
  constructor(props) {
    super(props);
    this.state = {
      toLogin: false,
      currentType: "image",
      uploading: false,
      uploadModalOpen: false,
      vimeoModalOpen: false,
      updateInfoModal: false,
      collectionInfoModal: false,
      assetCollectionID: null,
      searchKeyword: "",
      videoKeyword: "",
      imageKeyword: "",
      selectedAssetID: null,
      selectedAssetName: "",
      selectedAssetDescription: "",
      collectionName: "",
      collectionDescription: "",

      loaded: false,
      loadedAllVimeo: false,
      allVimeoVids: [],
      vimeos: [],
      videos: [],
      images: [],
      collectionInfo: {},
      vimeoVideosQuery: "",
    };

    this.uploadSubmit = this.uploadSubmit.bind(this);
    this.fetchAllVimeoVideos = this.fetchAllVimeoVideos.bind(this);
    this.saveVimeo = this.saveVimeo.bind(this);
    this.updateAssetInfo = this.updateAssetInfo.bind(this);
    this.reloadAssets = this.reloadAssets.bind(this);
    this.updateCollectionInfo = this.updateCollectionInfo.bind(this);
  }

  public async componentDidMount() {
    const {
      match,
      services: { isUserLoggedIn, adminAPI },
    } = this.props;
    const {
      params: { id: assetCollectionID },
    } = match;
    if (!isUserLoggedIn) {
      this.setState({ toLogin: true });
    }
    const [
      collectionInfoRes,
      vimeoRes,
      videoRes,
      imagesRes,
    ] = await Promise.all([
      adminAPI.getSingleItemGeneral("asset_collections", assetCollectionID),
      adminAPI.getCollectionVimeoItems(assetCollectionID),
      adminAPI.getCollectionVideoItems(assetCollectionID),
      adminAPI.getCollectionItems(assetCollectionID), // images
    ]);

    if (collectionInfoRes.ok) {
      // console.log("ColInfo" + JSON.stringify(collectionInfoRes, null, 2));
      // console.log("VimeoInfo" + JSON.stringify(vimeoRes, null, 2));
      // console.log("ImageInfo" + JSON.stringify(imagesRes, null, 2));
      // console.log("VideoInfo" + JSON.stringify(videoRes, null, 2));

      this.setState({
        vimeos: vimeoRes.data.assets,
        videos: videoRes.data.assets,
        images: imagesRes.data.assets,
        collectionInfo: collectionInfoRes.data,
        loaded: true,
        assetCollectionID,
      });
    }
  }

  public async reloadAssets() {
    const {
      services: { adminAPI },
    } = this.props;
    const { assetCollectionID } = this.state;
    const [vimeoRes, videoRes, imagesRes] = await Promise.all([
      adminAPI.getCollectionVimeoItems(assetCollectionID),
      adminAPI.getCollectionVideoItems(assetCollectionID),
      adminAPI.getCollectionItems(assetCollectionID), // images
    ]);

    this.setState({
      vimeos: vimeoRes.data.assets,
      videos: videoRes.data.assets,
      images: imagesRes.data.assets,
      loaded: true,
    });
  }

  public onLogout = () => {
    this.setState({ toLogin: true });
  };
  public goBack = () => {
    this.props.history.goBack();
  };

  public toggleUploadModal = () => {
    const current = this.state.uploadModalOpen;
    this.setState({ uploadModalOpen: !current });
  };
  public toggleVimeoModal = () => {
    const current = this.state.vimeoModalOpen;
    this.setState({ vimeoModalOpen: !current });
  };
  public toggleCollectionInfoModal = () => {
      const { collectionInfoModal, collectionInfo } = this.state;
    this.setState({ collectionInfoModal: !collectionInfoModal, collectionName: collectionInfo.Name, collectionDescription: collectionInfo.Description });
  };

  public addVimeoAsset = () => {
    this.setState({vimeoModalOpen: true});
    this.fetchAllVimeoVideos();
  }

  public async fetchAllVimeoVideos() {
    const {
      services: { adminAPI },
    } = this.props;

    // this.setState({ loadedAllVimeo: false});

    const { vimeoVideosQuery } = this.state;
    const allVimeoRes = await adminAPI.getVimeoVideos(vimeoVideosQuery);
    if (allVimeoRes.ok) {
      const allVimeoVids = allVimeoRes.data.videos;
      // console.log(JSON.stringify(allVimeoVids, null, 2));
      this.setState({ loadedAllVimeo: true, allVimeoVids });
    } else {
      toast.error("Could not fetch videos at this time");
    }
  }

  public async uploadSubmit(e) {
    e.preventDefault();

    const { uploading, assetCollectionID, uploadModalOpen } = this.state;

    this.setState({ uploading: true });

    const fileInputElement = e.target.elements.upld;
    const formData = new FormData();

    formData.append("asset_collection_id", assetCollectionID);
    formData.append("description", e.target.elements.description.value);

    for (const row of fileInputElement.files) {
      formData.append("files", row);
    }
    // console.log(JSON.stringify(formData, null, 2));
    const res = await this.props.services.adminAPI.updloadAsset(formData);

    if (res.ok) {
      this.setState({ uploading: false });

      toast.success("Success, asset is being optimized, may take a minute");

      setTimeout(this.reloadAssets, 12000);
    } else {
      toast.error("Failed to complete upload");
    }
  }

  public async saveVimeo(vid) {
    const item = {
      video: vid,
      collection: this.state.assetCollectionID,
    };
    const res = await this.props.services.adminAPI.saveVimeo(item);

    if (res.ok) {
      toast.success("Vimeo video successfully added");
      this.reloadAssets();
    } else {
      toast.error("Failed to add vimeo video");
    }
  }

  public async updateCollectionInfo() {
      const { collectionInfo, collectionName, collectionDescription, assetCollectionID } = this.state;
      const item = {
          ...collectionInfo,
          Name: collectionName,
          Description: collectionDescription
      }

      const res = await this.props.services.adminAPI.updateItemGeneral("asset_collections",item,item.AssetCollectionId);
      if(res.ok) {
          toast.success("Collection Info Updated Successfully");
          const updatedInfoRes = await this.props.services.adminAPI.getSingleItemGeneral("asset_collections", assetCollectionID);
          if(updatedInfoRes.ok) {
              this.setState({collectionInfo: updatedInfoRes.data})
          }else {toast.info('Collection Info Update, refresh your browser')}
      }

  }

  public async updateAssetInfo() {
    const {
      selectedAssetID,
      selectedAssetName,
      selectedAssetDescription,
    } = this.state;
    const item = {
      Name: selectedAssetName,
      Description: selectedAssetDescription,
    };
    const res = await this.props.services.adminAPI.updateAssetPartial(
      item,
      selectedAssetID
    );
    if (res.ok) {
      toast.success("Asset Infomation Updated Successfully");
      this.reloadAssets();
    }
  }

  public async deleteAsset(assetId) {
    const retVal = confirm("Do you want to continue ?");
    if (!retVal) {
      return;
    }
    const res = await this.props.services.adminAPI.deleteItemGeneral(
      "assets",
      assetId
    );
    if (res.ok) {
      toast.success("Asset successfully deleted");
      this.reloadAssets();
    } else {
      toast.error("Asset could not be deleted, try again");
    }
  }

  public changeAssetClickHandler = (asset) => {
    this.setState({
      updateInfoModal: true,
      selectedAssetID: asset.id,
      selectedAssetDescription: asset.Description,
      selectedAssetName: asset.Title,
    });
  };
  public selectTypeHandler = (e) => {
    this.setState({ currentType: e.target.value });
  };

  public onSearchChangeHandler = (e) => {
    this.setState({ searchKeyword: e.target.value });
  };

  public onQueryChangeHandler = (e) => {
    this.setState({ vimeoVideosQuery: e.target.value });
    this.fetchAllVimeoVideos();
  };

  public onVideoSearchHander = (e) => {
    this.setState({ videoKeyword: e.target.value });
  };

  public onImageSearchHandler = (e) => {
    this.setState({ imageKeyword: e.target.value });
  };

  public handlePropertyChange = (field, e) => {
    if (field === "Title") {
      this.setState({ selectedAssetName: e.target.value });
    }
    if (field === "Description") {
      this.setState({ selectedAssetDescription: e.target.value });
    }
    if(field === 'colName') {
        this.setState({collectionName: e.target.value});
    }
    if(field === "colDescription") {
        this.setState({collectionDescription: e.target.value});
    }
  };

  public closeInfoModal = () => {
    this.setState({ updateInfoModal: false });
  };

  public renderImages = () => {
    const { images, loaded, imageKeyword } = this.state;

    const filteredImages = images.filter((image) => {
      if (imageKeyword === "") {
        return image;
      } else {
        return image.Title.toLowerCase().includes(imageKeyword.toLowerCase());
      }
    });
    if (loaded) {
      return (
        <React.Fragment>
          <input
            style={{ width: "70%" }}
            type="text"
            className="custom-textfield"
            placeholder="Search Image Name"
            onChange={this.onImageSearchHandler}
          />
          <Grid width="80%">
            {images.length > 0 ? (
              filteredImages.map((item) => {
                return (
                  <AssetItem key={item.id} border={true}>
                    <div className="asset-wrapper">
                      <img
                        src={`${PROXIED_MEDIABASE}assets/${item.FileName}`}
                        alt="Image Asset"
                      />
                    </div>

                    <p className="asset-name">{item.Title}</p>
                    <EditRow>
                      <button
                        className="edit-asset green-button"
                        onClick={this.changeAssetClickHandler.bind(this, item)}
                      >
                        Edit
                      </button>
                      <i
                        className="fa fa-trash"
                        aria-hidden="true"
                        onClick={this.deleteAsset.bind(this, item.id)}
                      />
                    </EditRow>
                  </AssetItem>
                );
              })
            ) : (
              <p className="no-assets">THERE ARE NO IMAGE ASSETS YET!</p>
            )}
          </Grid>
          <button
            className="add-asset green-button"
            onClick={this.toggleUploadModal}
          >
            Upload Image
          </button>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff24" />;
    }
  };
  public renderVideos = () => {
    const { videos, loaded, videoKeyword } = this.state;
    const filteredVideos = videos.filter((video) => {
      if (videoKeyword === "") {
        return video;
      } else {
        return video.Title.toLowerCase().includes(videoKeyword.toLowerCase());
      }
    });
    if (loaded) {
      return (
        <React.Fragment>
          <input
            style={{ width: "70%" }}
            type="text"
            className="custom-textfield"
            placeholder="Search Video Name"
            onChange={this.onVideoSearchHander}
          />

          <Grid width="80%">
            {videos.length > 0 ? (
              filteredVideos.map((item) => {
                return (
                  <VideoItem key={item.id} border={true}>
                    <Player
                      playsInline={true}
                      src={PROXIED_MEDIABASE + "assets/" + item.FileName}
                      height={240}
                      width={360}
                    >
                      <BigPlayButton position="center" />
                    </Player>

                    <p className="asset-name">{item.Title}</p>
                    <EditRow>
                      <button
                        className="edit-asset green-button"
                        onClick={this.changeAssetClickHandler.bind(this, item)}
                      >
                        Edit
                      </button>
                      <i
                        className="fa fa-trash"
                        aria-hidden="true"
                        onClick={this.deleteAsset.bind(this, item.id)}
                      />
                    </EditRow>
                  </VideoItem>
                );
              })
            ) : (
              <p className="no-assets">THERE ARE NO VIDEO ASSETS YET!</p>
            )}
          </Grid>
          <button
            className="green-button add-asset"
            onClick={this.toggleUploadModal}
          >
            Add Video Asset
          </button>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff24" />;
    }
  };
  public renderVimeos = () => {
    const { vimeos, loaded, searchKeyword } = this.state;
    const filteredVimeos = vimeos.filter((vimeo) => {
      if (searchKeyword === "") {
        return vimeo;
      } else {
        return vimeo.Title.toLowerCase().includes(searchKeyword.toLowerCase());
      }
    });
    if (loaded) {
      return (
        <React.Fragment>
          <input
            type="text"
            className="custom-textfield"
            style={{ width: "70%" }}
            placeholder="Search Vimeo Name"
            value={this.state.searchKeyword}
            onChange={this.onSearchChangeHandler}
          />
          <Grid width="80%">
            {vimeos.length > 0 ? (
              filteredVimeos.map((item) => {
                return (
                  <VideoItem key={item.id} border={true}>
                    <Vimeo
                      video={`https://player.vimeo.com/video/${item.FileName}`}
                      width="240px"
                    />
                    <p className="asset-name">{item.Title}</p>
                    <EditRow>
                      <button
                        className="edit-asset green-button"
                        onClick={this.changeAssetClickHandler.bind(this, item)}
                      >
                        Edit
                      </button>
                      <i
                        className="fa fa-trash"
                        aria-hidden="true"
                        onClick={this.deleteAsset.bind(this, item.id)}
                      />
                    </EditRow>
                  </VideoItem>
                );
              })
            ) : (
              <p className="no-assets">THERE ARE NO VIMEO ASSETS YET!</p>
            )}
          </Grid>
          <button
            className="green-button add-asset"
            onClick={this.addVimeoAsset}
          >
            Add Vimeo Asset
          </button>
        </React.Fragment>
      );
    } else {
      return <Loader color="#acff24" />;
    }
  };

  public renderAddAssetModal = () => {
    return (
      <Modal
        visible={this.state.uploadModalOpen}
        effect="fadeInDown"
        onClickAway={this.toggleUploadModal}
        width="480"
        height="240"
      >
        <ModalWrapper>
          <form onSubmit={this.uploadSubmit}>
            <input
              id="upld"
              type="file"
              name="upld"
              accept=".mp3,.mp4,.png,.jpeg,.jpg"
              multiple={true}
              required={true}
            />

            <input
              id="description"
              type="description"
              name="description"
              placeholder="description"
              required={true}
              className="custom-textfield"
            />

            <Loader color="#3EE9F7" loaded={!this.state.uploading}>
              <button type="submit" className="upload-btn green-button">
                Upload
              </button>
              {/* <Button onClick={this.uploadToggle} className="adminmodalbutton">
                Cancel
              </Button> */}
            </Loader>
          </form>
        </ModalWrapper>
      </Modal>
    );
  };

  public renderAddVimeoModal = () => {
    const { allVimeoVids, loadedAllVimeo, searchKeyword, query } = this.state;

    return (
      <Modal
        visible={this.state.vimeoModalOpen}
        effect="fadeInDown"
        onClickAway={this.toggleVimeoModal}
        width="80%"
        height="800"
      >
        {loadedAllVimeo ? (
          <ModalWrapper>
            <input
              type="text"
              className="custom-textfield"
              placeholder="Search for a vimeo video"
              value={this.state.vimeoVideosQuery}
              onChange={this.onQueryChangeHandler}
            />
            <Grid width="100%" height="90%">
              {allVimeoVids.map((vimeo) => {
                return (
                  <VideoItem key={vimeo.id} border={true}>
                    <Vimeo
                      video={`https://player.vimeo.com/video/${vimeo.VideoData.id}`}
                      width="240px"
                    />
                    <p className="asset-name">{vimeo.VideoData.name}</p>
                    <button
                      className="add-vimeo green-button"
                      onClick={this.saveVimeo.bind(this, vimeo.id)}
                    >
                      Add
                    </button>
                  </VideoItem>
                );
              })}
            </Grid>
          </ModalWrapper>
        ) : (
          <Loader color="#acff24" loaded={loadedAllVimeo} />
        )}
      </Modal>
    );
  };
  public renderEditInfoModal = () => {
    return (
      <Modal
        visible={this.state.updateInfoModal}
        effect="fadeInDown"
        onClickAway={this.closeInfoModal}
        width="480"
        height="240"
      >
        <ModalWrapper>
          <p className="modal-title">Change Asset Details</p>
          <form style={{ padding: "0 0 2em 0" }}>
            <textarea
              rows={3}
              cols={10}
              id="title"
              placeholder="Asset Name"
              value={this.state.selectedAssetName}
              className="custom-textfield"
              onChange={this.handlePropertyChange.bind(this, "Title")}
              required={true}
            />
            <textarea
              rows={3}
              cols={10}
              id="description"
              name="description"
              placeholder=" Asset Description"
              value={this.state.selectedAssetDescription}
              onChange={this.handlePropertyChange.bind(this, "Description")}
              className="custom-textfield"
            />
          </form>

          <Loader color="#3EE9F7" loaded={!this.state.uploading}>
            <button
              style={{ marginBottom: "2em" }}
              type="submit"
              className="upload-btn green-button"
              onClick={this.updateAssetInfo}
            >
              Update
            </button>
          </Loader>
        </ModalWrapper>
      </Modal>
    );
  };
  public renderCollectionInfoModal = () => {
    return (
      <Modal
        visible={this.state.collectionInfoModal}
        effect="fadeInDown"
        onClickAway={this.toggleCollectionInfoModal}
        width="480"
        height="240"
      >
        <ModalWrapper>
          <p className="modal-title">Change Asset Details</p>
          <form style={{ padding: "0 0 2em 0" }}>
            <textarea
              rows={3}
              cols={10}
              id="title"
              placeholder={this.state.collectionInfo.Name}
              value={this.state.collectionName}
              className="custom-textfield"
              onChange={this.handlePropertyChange.bind(this, "colName")}
              required={true}
            />
            <textarea
              rows={3}
              cols={10}
              id="description"
              name="description"
              placeholder={this.state.collectionInfo.Description}
              value={this.state.collectionDescription}
              onChange={this.handlePropertyChange.bind(this, "colDescription")}
              className="custom-textfield"
            />
          </form>

          <Loader color="#3EE9F7" loaded={!this.state.uploading}>
            <button
              style={{ marginBottom: "2em" }}
              type="submit"
              className="upload-btn green-button"
              onClick={this.updateCollectionInfo}
            >
              Update
            </button>
          </Loader>
        </ModalWrapper>
      </Modal>
    );
  };

  public render() {
    const { toLogin, currentType, collectionInfo } = this.state;
    if (toLogin) {
      return <Redirect to="/login" />;
    }
    let content: any = null;
    if (currentType === "image") {
      content = this.renderImages();
    }
    if (currentType === "video") {
      content = this.renderVideos();
    }
    if (currentType === "vimeo") {
      content = this.renderVimeos();
    }

    return (
      <div>
        <ToastContainer />
        <Navbar logoutParent={this.onLogout} />
        <Page>
          {this.renderAddAssetModal()}
          {this.renderAddVimeoModal()}
          {this.renderEditInfoModal()}
          {this.renderCollectionInfoModal()}
          <HeaderSection width="80%">
            <p
              className="back"
              style={{marginBottom: '0 !important'}}           
              onClick={this.goBack}
            >
              &lt; Back
            </p>
            
          </HeaderSection>
            <CollectionInfo>
              <div className="collection-info">
                <h1 className="collection-name">{collectionInfo.Name}</h1>
                <p className="collection-description">
                  {collectionInfo.Description}
                </p>
              </div>
              <i
                className="fa fa-pencil-square-o"
                aria-hidden="true"
                onClick={this.toggleCollectionInfoModal}
              />
            </CollectionInfo>
          <HeaderSection width="600px">
            <button
              className={`asset-type ${
                currentType === "image" ? "b-active" : ""
              }`}
              value="image"
              onClick={this.selectTypeHandler}
            >
              Images
            </button>
            <button
              className={`asset-type  ${
                currentType === "video" ? "b-active" : ""
              }`}
              value="video"
              onClick={this.selectTypeHandler}
            >
              Videos
            </button>
            <button
              className={`asset-type ${
                currentType === "vimeo" ? "b-active" : ""
              }`}
              value="vimeo"
              onClick={this.selectTypeHandler}
            >
              Vimeo
            </button>
          </HeaderSection>
          {content}
        </Page>
      </div>
    );
  }
}

export default withServices(AssetCollections);



// WEBPACK FOOTER //
// ./src/pages/Admin/AssetCollections/AssetCollectionsNew/AssetCollections.Component.tsx